/**
 * Unified EventBus — merged from Designer's eventBus.js
 * Events from both Studio (DOM CustomEvents) and Designer (EventBus)
 */

class EventBus {
  constructor() {
    this.events = new Map()
  }

  on(event, callback) {
    if (!this.events.has(event)) {
      this.events.set(event, new Set())
    }
    this.events.get(event).add(callback)
    return () => this.off(event, callback)
  }

  once(event, callback) {
    const wrapped = (...args) => {
      callback(...args)
      this.off(event, wrapped)
    }
    return this.on(event, wrapped)
  }

  off(event, callback) {
    const cbs = this.events.get(event)
    if (cbs) {
      cbs.delete(callback)
      if (cbs.size === 0) this.events.delete(event)
    }
  }

  emit(event, ...args) {
    const cbs = this.events.get(event)
    if (cbs) {
      cbs.forEach(cb => {
        try { cb(...args) }
        catch (e) { console.error(`[EventBus] Error in handler for "${event}":`, e) }
      })
    }
  }

  clear(event) {
    if (event) this.events.delete(event)
    else this.events.clear()
  }
}

export const eventBus = new EventBus()
export { EventBus }

// Merged event constants from both apps
export const EVENTS = {
  // Auth
  USER_LOGIN: 'user:login',
  USER_LOGOUT: 'user:logout',
  USER_UPDATE: 'user:update',
  AUTH_CHANGED: 'auth:changed',

  // Mode
  MODE_CHANGE: 'mode:change',
  MODE_ACTIVATED: 'mode:activated',
  MODE_DEACTIVATED: 'mode:deactivated',
  // L2 subtabs (H-135a): (mode, tabId, prevTabId)
  SUBTAB_CHANGE: 'subtab:change',

  // Create mode (Studio)
  GENERATION_COMPLETE: 'generation:complete',
  IMAGE_SELECT: 'image:select',
  INTENT_FILTER: 'intentcard:filter',
  VISION_COMPLETE: 'vision:complete',
  // Funnel: a finished result is put ON a product so the user can GET theirs —
  // the terminal is the purchase, never "sell" (ADR-005 2.7.0, commercial-model §1).
  PUT_ON_PRODUCT: 'create:put-on-product',

  // Design mode (Designer)
  PRODUCT_SELECT: 'product:select',
  PRODUCT_CHANGE: 'product:change',
  VARIANT_SELECT: 'variant:select',
  FACE_SELECT: 'face:select',
  SDK_READY: 'sdk:ready',
  SDK_ERROR: 'sdk:error',
  CANVAS_UPDATE: 'canvas:update',
  LAYER_ADD: 'layer:add',
  LAYER_UPDATE: 'layer:update',
  LAYER_DELETE: 'layer:delete',
  MATERIAL_SELECT: 'material:select',
  MATERIAL_UPLOAD: 'material:upload',
  // H-140: the Arts panel finished a materials page load (payload: {append}).
  MATERIALS_LOADED: 'materials:loaded',
  FAVORITE_ADD: 'favorite:add',
  FAVORITE_REMOVE: 'favorite:remove',
  DESIGN_SAVED: 'design:saved',

  // UI
  TOAST_SHOW: 'toast:show',
  MODAL_OPEN: 'modal:open',
  MODAL_CLOSE: 'modal:close',
  LOADING_START: 'loading:start',
  LOADING_END: 'loading:end',
}

export default eventBus
